import privacySettings from './privacySettings';

export default () => ({
  // DNT-configuration
  nt: false,
  // Script Errors/Exceptions
  scriptErrors: [],
  // actual timestamp
  now: new Date(),
  // initialising accomplished
  inited: 0,
  // IAM Site-Element
  IAMPageElement: null,
  // collect runtimes
  runtimes: '',
  // global Parameter Storage for Events
  globalParams: {},
  // global Event
  globalEvent: '',
  // auto events frequency capping
  autoEventSent: false,
  // iodata switch
  autoEventsSite: '',
  // store last auto event
  lastAutoEvent: '',
  // eliminate possible privacy issues
  protectPrivacy: privacySettings.none,
  // Persistence of measured data
  persistence: true,
  // Empty hybrid state
  hybrid: {
    detected: false,
    platform: '',
  },
  pixelType: 'cp',
});
